



































import { Component, Vue } from 'vue-property-decorator'
import api from '@/services/api'

@Component
export default class extends Vue {
    mail = ''
    password = ''

    async onClaim() {
        await api.request('PATCH', 'users/me', {
            email: this.mail,
            password: this.password,
            isAnon: false,
        })

        await api.login(this.mail, this.password)

        this.$router.push({
            path: '/rate',
        })
    }
}
